import React from 'react';
import DesktopProfileVideoPrimis from './primis/DesktopProfileVideo';
const DesktopProfileVideo = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopProfileVideoPrimis, {
        safety: safety
    });
};
DesktopProfileVideo.displayName = 'DesktopProfileVideo';
export default DesktopProfileVideo;
